import { render, staticRenderFns } from "./xxbstatisticanalysis.vue?vue&type=template&id=46975afa&scoped=true&"
import script from "./xxbstatisticanalysis.vue?vue&type=script&lang=js&"
export * from "./xxbstatisticanalysis.vue?vue&type=script&lang=js&"
import style0 from "./xxbstatisticanalysis.vue?vue&type=style&index=0&id=46975afa&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46975afa",
  null
  
)

export default component.exports